export const DEVELOPMENT = 'DEVELOPMENT'
export const PRODUCTION = 'PRODUCTION'